import { FC } from 'react';

const ConsoleHeader: FC = () => (
  <div className="ai-console__header">
    <h1 className="ai-console__title">AI Recruiter Console</h1>
    <p className="ai-console__description">
      Review AI-ranked applicants, triage outreach, and assign to recruiters
      across all AI-enabled companies and job orders.
    </p>
  </div>
);

export default ConsoleHeader;
